import React, { useState } from 'react';
import { Button, Grid, Header, Sidebar } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import PageSubNav from './navigation/PageSubNav';
import PageHeader from './PageHeader';
import PageNav from './navigation/PageNav';
import HeroImage from './HeroImage';
import { adminLogout } from '../actions/auth';
import EnterpriseMismatch from './admin/EnterpriseMismatch';
import PageMobileSubNav from './PageMobileSubNav';
import PageFooter from './PageFooter';
import { isAllLocations } from '../helpers/utils';
import SessionMessage from './common/sessionMessage/SessionMessage';

const Body = ({ showSubNav, children }) => (
    <Grid.Column
        mobile={12}
        tablet={12}
        computer={showSubNav ? 10 : 12}
        largeScreen={showSubNav ? 10 : 12}
        widescreen={showSubNav ? 10 : 12}
        className="oslte-body">
        <SessionMessage />
        {children}
    </Grid.Column>
);

const SubNav = ({ subNav, enterpriseId, isIBC, isPMEC }) => (
    <Grid.Column className="oslte-subnav computer" only="computer" computer="2" largeScreen="2" widescreen="2">
        <PageSubNav subNav={subNav} enterpriseId={enterpriseId} isIBC={isIBC} isPMEC={isPMEC} />
    </Grid.Column>
);

const MobileSubNav = ({ subNav, enterpriseId, visible, setShowMobileSubNav }) => (
    <Sidebar className="oslte-subnav mobile" animation="overlay" direction="right" visible={visible} width="wide">
        <PageMobileSubNav subNav={subNav} enterpriseId={enterpriseId} setShowMobileSubNav={setShowMobileSubNav} />
    </Sidebar>
);

const AdminRow = ({ dispatch, name, ecpdId, isMultiTenant, hostEnterpriseName, hostEnterpriseEcpdId }) => (
    <Grid.Row className="no-print" style={{ background: 'white' }}>
        <Grid.Column width="10" verticalAlign="middle">
            <Header as="h3">
                {isAllLocations()
                    ? 'All Locations'
                    : `${name} (${ecpdId})${
                          isMultiTenant && hostEnterpriseName && hostEnterpriseEcpdId ? ` --> ${hostEnterpriseName} (${hostEnterpriseEcpdId})` : ''
                      }`}
            </Header>
        </Grid.Column>
        <Grid.Column width="2" verticalAlign="middle" textAlign="right">
            <Button onClick={() => dispatch(adminLogout())}>Exit</Button>
        </Grid.Column>
    </Grid.Row>
);

const PageWrapper = (props) => {
    const {
        children,
        location,
        enterpriseId,
        isIBC,
        isPMEC,
        enterpriseName,
        ecpdId,
        isRentalNib,
        isMultiTenant,
        linkedEnterprises,
        hostEnterpriseName,
        hostEnterpriseEcpdId,
        hero,
        signedIn,
        showHeader = true,
        showNav = true,
        subNav = false,
        showEnterpriseSelection = false,
        admin = false
    } = props;
    const showSubNav = !!subNav && !showEnterpriseSelection;
    const dispatch = useDispatch();
    const [showMobileSubNav, setShowMobileSubNav] = useState(false);
    const enterpriseIdHash = location.hash.split('?')[0];

    const mismatch =
        admin &&
        !isRentalNib &&
        !!enterpriseId &&
        !!enterpriseIdHash &&
        `#${enterpriseId}` !== enterpriseIdHash &&
        !linkedEnterprises?.some((link) => `#${link.enterpriseId}` === enterpriseIdHash);
    const showHeroImage = location.pathname === '/';

    return mismatch ? (
        <EnterpriseMismatch type="mismatch" />
    ) : (
        <>
            {(showHeader || showNav) && (
                <div className="oslte-header-wrapper no-print">
                    <Grid columns={2} width="12" className="page">
                        {showHeader && <PageHeader {...props} />}
                        {showNav && (
                            <PageNav
                                location={location}
                                subNav={subNav}
                                setShowMobileSubNav={setShowMobileSubNav}
                                showEnterpriseSelection={showEnterpriseSelection}
                            />
                        )}
                    </Grid>
                </div>
            )}
            <Grid stackable className="oslte-body-wrapper page">
                {signedIn && !showEnterpriseSelection && showHeroImage && <HeroImage hero={hero} />}
                {signedIn && !showEnterpriseSelection && admin && (
                    <AdminRow
                        dispatch={dispatch}
                        name={enterpriseName}
                        ecpdId={ecpdId}
                        isMultiTenant={isMultiTenant}
                        hostEnterpriseName={hostEnterpriseName}
                        hostEnterpriseEcpdId={hostEnterpriseEcpdId}
                    />
                )}
                <Grid.Row className="oslte-content-wrapper">
                    {signedIn && showSubNav && <SubNav subNav={subNav} enterpriseId={enterpriseId} isIBC={isIBC} isPMEC={isPMEC} />}
                    {signedIn && (
                        <MobileSubNav
                            subNav={subNav}
                            enterpriseId={enterpriseId}
                            visible={showMobileSubNav}
                            setShowMobileSubNav={setShowMobileSubNav}
                        />
                    )}
                    <Body showSubNav={showSubNav}>{children}</Body>
                </Grid.Row>
            </Grid>
            {signedIn && <PageFooter />}
        </>
    );
};

export default PageWrapper;
